import { render, staticRenderFns } from "./input-image-multi.vue?vue&type=template&id=06128f02&scoped=true&"
import script from "./input-image-multi.vue?vue&type=script&lang=js&"
export * from "./input-image-multi.vue?vue&type=script&lang=js&"
import style0 from "./input-image-multi.vue?vue&type=style&index=0&id=06128f02&lang=scss&scoped=true&"
import style1 from "./input-image-multi.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06128f02",
  null
  
)

export default component.exports